import { Box, COLOR_PALETTE, Flex, Text } from '@inflearn/ds-react-next';
import { KoOnly, useLang } from '@inflearn/i18n-tools';
import { useTranslation } from 'next-i18next';

import type { AccountInventoryResponseDto } from '../../../../../../../resources/@types/accountSchema';

export function UserInventory({ userInventory }: { userInventory: AccountInventoryResponseDto }) {
  const { t } = useTranslation();
  const { isKo } = useLang();

  return (
    <Flex gap={12} mt={12}>
      <InfoBox label={t('강의 수')} value={userInventory.voucherCount} unit={t('개')} />
      <KoOnly>
        <InfoBox label={t('포인트')} value={userInventory.point} unit={isKo ? t('잎') : ''} />
        <InfoBox label={t('쿠폰')} value={userInventory.couponCount} unit={t('개')} />
      </KoOnly>
    </Flex>
  );
}

function InfoBox({ label, value = 0, unit }: { label?: string; value?: number; unit: string }) {
  return (
    <Box
      px={12}
      py={8}
      w="100%"
      css={{ borderRadius: 8, border: `1px solid ${COLOR_PALETTE.gray[3]}` }}
    >
      <Flex justify="flex-start">
        <Text component="span" fw={500} fz={14} c="gray.9">
          {label}
        </Text>
      </Flex>
      <Flex justify="flex-end" align="center" mt={12}>
        <Text component="span" fw={600} fz={20} c="gray.9">
          {value}
        </Text>
        <Text component="span" fw={500} fz={14} c="gray.6" ml={2}>
          {unit}
        </Text>
      </Flex>
    </Box>
  );
}
